export default __webpack_public_path__ + "static/media/empty-mailbox.1cb435e6.svg";